import React, { useEffect, useState } from 'react'
import { config } from '../../../../config/config'
import { onClientSide, sendDispatchEvent } from 'utils/utils'
import Button from '@/components/Button'
import useModal from '@/modern/actions/useModal'
import LoadingModal from './LoadingModal'
import SuccessModal from './SuccessModal'
import ServerErrorModal from './ServerErrorModal'
import { useFetchGrantConsent } from './useFetchGrantConsent'
import ModalContainer from '@/modern/components/ModalContainer'
import * as S from './style'

const hideModalPromoBlackFair = config.hideModalPromoBlackFairao2024

function PromoBlackFairModal({ email, showMessageSent = true }) {
  const { closeModal, modal } = useModal('promoBlackFair')
  const [showModalPromoBlackFair, setShowModalPromoBlackFair] = useState(false)
  const { isLoading, result, fetchConsent } = useFetchGrantConsent(email)
  const showMessageSentState = false

  function handleCloseModal(event) {
    if (!onClientSide()) return

    if (event) {
      event.stopPropagation()
    }
    sendDispatchEvent('CliquePosLeadSairSorteio')
    closeModal()
    window.localStorage.setItem(hideModalPromoBlackFair, true)
  }

  function handleGrantConsent() {
    if (!onClientSide()) return
    sendDispatchEvent('cliquePosLeadQueroParticiparSorteio')
    fetchConsent(email)
  }

  useEffect(() => {
    if (onClientSide()) {
      if (modal) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
      return () => {
        document.body.style.overflow = ''
      }
    }
  }, [modal])

  useEffect(() => {
    if (!onClientSide()) return
    const isBlackFairModalOpen = JSON.parse(
      window.localStorage.getItem(hideModalPromoBlackFair)
    )

    if (isBlackFairModalOpen) {
      setShowModalPromoBlackFair(true)
    }
  }, [])

  if (result.statusCode >= 500) {
    return <ServerErrorModal email={email} />
  }

  if (isLoading) {
    return <LoadingModal />
  }

  if (result.success || result.statusCode === 400) {
    if (!onClientSide()) return
    window.localStorage.setItem(config.promoBlackFairao2024, true)

    return <SuccessModal email={email} />
  }

  if (showModalPromoBlackFair) return null
  if (!showMessageSentState) return null

  return (
    <ModalContainer
      align="center"
      show={modal}
      useWhiteBox
      onBgClick={e => handleCloseModal(e)}
    >
      <S.Wrapper>
        <S.CloseButton onClick={e => handleCloseModal(e)}>
          <S.CloseIcon name="Close_1" fill="#2E2E37" size="24" />
        </S.CloseButton>
        {showMessageSent ? <S.Heading>Mensagem enviada!</S.Heading> : null}
        <S.ImageContainer>
          <img
            src="/assets/img/webp/promo-black-2024-.webp"
            alt="Promo Black feirão 2024"
          />
        </S.ImageContainer>
        <S.Heading>
          Concorra ao prêmio de <br /> 50 mil* e prêmios de R$ 150!
        </S.Heading>
        <S.Text>
          Clique no botão e receba um e-mail em até 24 horas para
          <br /> garantir sua participação na promoção.
        </S.Text>
        <S.ButtonsContainer>
          <Button onClick={() => handleGrantConsent()}>Quero participar</Button>
        </S.ButtonsContainer>
        <S.Info>
          *Condições válidas até 30/11/2024. Consulte regulamento da promoção em:
          <br />
          https://webmotors.promocaoblackfeirao.com.br/
        </S.Info>
      </S.Wrapper>
    </ModalContainer>
  )
}

export default PromoBlackFairModal